import { render } from "./WTextSkeleton.vue?vue&type=template&id=115ab2f4&ts=true"
import script from "./WTextSkeleton.vue?vue&type=script&lang=ts"
export * from "./WTextSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__